import { handleWidgetUpdate } from '@juvare/common-form-ui/WidgetForm/Utils';
import { WidgetHandler } from '@juvare/common-form-ui/WidgetHandler';
import { ContactManagementConfigContext } from '@juvare/contact-management/ui/providers';
import { useAnonymousClient } from '@juvare/platform-sdk-react/ui/hooks';
import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';
import Alert from '@mui/material/Alert';
import React from 'react';
import { type } from './types';
const WidgetMessageInfo = (props) => {
    const context = React.useContext(ContactManagementConfigContext);
    const messageTypeClient = useAnonymousClient(context.appName, 'messageType');
    const [messageTypeAndInfo, setMessageTypeAndInfo] = React.useState();
    React.useEffect(() => {
        messageTypeClient
            .storageList({
            filter: [
                { column: 'status', op: '=', value: 'active' },
                {
                    column: 'name',
                    op: '=',
                    value: props.rootData.messageType,
                },
            ],
            limit: 1,
        })
            .then((result) => {
            if (result.rows[0].columns.name && result.rows[0].columns.alertInfo) {
                setMessageTypeAndInfo({
                    messageTypeName: result.rows[0].columns.name,
                    messageTypeInfo: result.rows[0].columns.alertInfo,
                });
            }
        })
            .catch((error) => console.log(error));
    }, [messageTypeClient, props.rootData.messageType]);
    return (React.createElement(React.Fragment, null, (messageTypeAndInfo === null || messageTypeAndInfo === void 0 ? void 0 : messageTypeAndInfo.messageTypeName) && (messageTypeAndInfo === null || messageTypeAndInfo === void 0 ? void 0 : messageTypeAndInfo.messageTypeInfo) && (React.createElement(Alert, { severity: 'info' },
        React.createElement(Typography, { variant: 'inherit', sx: { fontWeight: 400 } },
            messageTypeAndInfo.messageTypeName,
            ": ",
            messageTypeAndInfo.messageTypeInfo)))));
};
const WidgetMessageInfoEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props),
        React.createElement(WidgetMessageInfo, Object.assign({}, props))));
};
export const widgetMessageInfo = {
    type,
    createWidget: () => ({
        type,
        key: 'messageInfo',
    }),
    update: (props) => {
        const handler = new WidgetHandler(props);
        const prevData = handler.config.selectedMessageType;
        props.config.selectedMessageType = props.rootData.messageType;
        return prevData !== props.config.selectedMessageType || handleWidgetUpdate(props);
    },
    component: WidgetMessageInfo,
    icon: React.createElement(InfoOutlinedIcon, null),
    editorComponent: WidgetMessageInfoEditor,
};
